import React from "react";
import { CoreUtils } from "@lib/common";
import styled, { css } from "styled-components";
const { shadeAlternate } = CoreUtils.colors;
const Tabs = styled("div") `
  background: #fff; 
  display: flex;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 16px;
  border-bottom: 1px solid #ebebeb;
`;
const Tab = styled("div") `
  background: ${({ theme }) => shadeAlternate(0.08, theme.box.background)};
  flex-grow: 1;
  flex-basis: 0;
  cursor: pointer;
  border-radius: 4px;
  ${({ active }) => !active
    ? ""
    : css `
            color: #fff;
            background: ${({ theme }) => theme.colors.primary};
        `};
`;
const TabLabel = styled("div") `
  text-align: center;
  padding: 11px 0;
`;
export const ModalMobileTabs = ({ value, tabs, onChange }) => {
    return (React.createElement(Tabs, null, tabs.map((t, i) => (React.createElement(Tab, { key: i, active: t.value === value, onClick: () => onChange(t) },
        React.createElement(TabLabel, null, t.label))))));
};
//# sourceMappingURL=modalMobileTab.js.map